import { Component, OnInit } from '@angular/core';
import { ApiParametrosService } from 'src/app/services/api-parametros.service';
import { Router } from '@angular/router';
import { Globals } from 'src/app/globals';
import { IdProcedimiento } from 'src/app/models/IdProcedimiento';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'app-menu-obra',
  templateUrl: './menu-obra.component.html',
  styleUrls: ['./menu-obra.component.css']
})
export class MenuObraComponent implements OnInit {

  public idProcedimiento: IdProcedimiento;
  public estatusSubir: string;
  public estatusPropuesta: string;

   /*Opciones Menu*/
   public info: boolean = true;
   public plazos_fechas: boolean = false;
   public propuesta: boolean = false;
   public subir_propuesta: boolean = false;

  constructor(private apiParams: ApiParametrosService, private router: Router, public globals: Globals) { }

  ngOnInit() {
    

    this.idProcedimiento = this.apiParams.getIdProcedimiento();

    if (isNullOrUndefined(this.idProcedimiento)) {
      this.router.navigateByUrl('/procs');
      return;
    }
  }


  ActualizaMenu(event):void{
    this.estatusSubir = event.estatusSubir;
    this.estatusPropuesta = event.estatusPropuesta;
    //this.estatusProc = '3';
  }



  ActualizaView(opcion: string){
    /*Refresca los componentes que se deben mostrar al usuario*/
    if (opcion === 'info') {
      this.info = true;
      this.plazos_fechas = false;
      this.propuesta = false;
      this.subir_propuesta = false;
    }

    if (opcion === 'plazos_fechas') {
      this.info = false;
      this.plazos_fechas = true;
      this.propuesta = false;
      this.subir_propuesta = false;
    }

    if (opcion === 'propuesta') {
      this.info = false;
      this.plazos_fechas = false;
      this.propuesta = true;
      this.subir_propuesta = false;
    }

    if (opcion === 'subir_propuesta') {
      this.info = false;
      this.subir_propuesta = true;
      this.plazos_fechas = false;
      this.propuesta = false;
    }

  }

}
